import type { Image } from './Image';

export enum PetType {
  CAT = 'cat',
  DOG = 'dog',
  PUPPY = 'puppy',
}

export type PetCounts = {
  dogCount: number;
  catCount: number;
  puppyCount: number;
};

export const AdditionalDetailsValues = ['custom', 'depends', 'pill', 'topical', 'injection'];

// BasePetDetail  represents the details required when adding a new pet detail
// PetDetails are what will be returned from the Pet API when a pet already has some
export type BasePetDetail = {
  slug: string;
  value: string;
  additionalInformation: string;
};

export type PetDetailConfig = {
  id?: number;
  displayName: string;
  serviceTypes: string[];
  multiselect: boolean;
  valueDisplayName: string;
};

export type PetDetail = BasePetDetail & PetDetailConfig;

export type PetDetailForDisplay = BasePetDetail & {
  displayName: string;
  valueDisplayName: string;
};

export type PetDetailValueOption = {
  displayName: string;
  value: string;
};

export type PetDetailOption = {
  slug: string;
  displayName: string;
  serviceTypes: string[];
  multiselect: boolean;
  options: PetDetailValueOption[];
  petTypes: string[];
};

export type PetDetailsOptions = PetDetailOption[];

export type PetOptionsResponse = {
  data: {
    actions: {
      POST: {
        petDetails: {
          child: {
            children: PetDetailsOptions;
          };
        };
      };
    };
  };
};

export type PetsResponse = { pets: Pet[]; memorializedPets: Pet[] };

export type Pet = {
  active: boolean;
  adoptionDate: string | null;
  ageMonths: number | '';
  ageYears: number | '';
  birthday: string;
  birthdayDisplay: string;
  breeds: string[];
  careInstructions: string;
  defaultImage: Image;
  description: string | null | undefined;
  dogSize: string;
  emergencyContactInformation: string;
  gender: string;
  houseTrained: boolean | null | undefined;
  houseTrainedDesc: string | null | undefined;
  id: string;
  implant: boolean | null | undefined;
  isPuppy: boolean;
  name: string;
  notes: string | null | undefined;
  opk?: string | null;
  owner: string;
  petDetails: PetDetail[];
  petType: PetType;
  pk: number | '';
  playsCats: boolean | null | undefined;
  playsCatsDesc: string | null | undefined;
  playsChildren: boolean | null | undefined;
  playsChildrenDesc: string | null | undefined;
  playsDogs: boolean | null | undefined;
  playsDogsDesc: string | null | undefined;
  spayedNeutered: boolean | null | undefined;
  specialRequirements: string | null | undefined;
  unit?: string;
  url: string;
  urls: {
    images: string;
  };
  veterinaryInformation: string;
  insuranceProvider: string | null;
  webUrl: string;
  weight: number | '';
  weightObj: Array<{
    unit: string;
    value: string;
  }>;
  canAddNotes?: boolean;
  isMemorialized: boolean | null;
  memorialDate: string | null;
};
